import { DeclineFeedback } from '@pflegia/types/common/enums/decline-feedback.enum';

export {
  /** @deprecated Import from @pflegia/types/common instead. */
  DeclineFeedback,
};
